import React from "react";

/**
 * This component is used to display the required
 * privacy statement which can be found in a link in the
 * about tab.
 */
// Theme context, default to light theme
const ThemeContext = React.createContext('light');

// Signed-in user context
const UserContext = React.createContext({
  name: 'Guest',
});

class Privacy extends React.Component {
  render() {
    const {signedInUser, theme} = this.props;

    // App component that provides initial context values
    return (
      <ThemeContext.Provider value={theme}>
        <UserContext.Provider value={signedInUser}>
          <Layout />
        </UserContext.Provider>
      </ThemeContext.Provider>
    );
  }
}

function Layout() {
  return (
    <div>
      <Content />
    </div>
  );
}

// A component may consume multiple contexts             {user => (
           // <ProfilePage user={user} theme={theme} />
           // )}
function Content() {
  return (
    <ThemeContext.Consumer>
      {theme => (
        <UserContext.Consumer>

        </UserContext.Consumer>
      )}
    </ThemeContext.Consumer>
  );
}

export default Privacy;
